import { Controller } from "@hotwired/stimulus"

// Manages each individual date-input + clear-button pair inside a
// .clear-date-wrapper element.
//
// Usage (one controller instance per wrapper div):
//
//   <div class="clear-date-wrapper" data-controller="clear-date">
//     <%= date_field_tag :name, value,
//           data: { clear_date_target: "input",
//                   action: "change->clear-date#change" } %>
//     <button type="button" class="clear-date-btn"
//             data-clear-date-target="button"
//             data-action="click->clear-date#clear"
//             aria-label="Clear date">&times;</button>
//   </div>
//
// Replaces the per-page inline <script> blocks that previously registered
// global jQuery event handlers with page-specific CSS-class selectors and
// namespaced event names (e.g. clearDateOrders / clearDateInvoices). Stimulus
// scopes each instance to its own element so no selectors or namespaces are
// needed, and Turbo lifecycle (connect/disconnect) prevents double-binding.

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this._updateButton()
  }

  // Fired via data-action="change->clear-date#change" on the date input.
  // Updates the × button, then submits the form. Uses requestSubmit() so the
  // native submit event fires and Turbo can intercept it for frame navigation.
  change() {
    this._updateButton()
    this.inputTarget.form.requestSubmit()
  }

  // Fired via data-action="click->clear-date#clear" on the × button.
  // Clears the date value, hides the button, and submits via requestSubmit()
  // so Turbo frame targeting is honoured.
  clear() {
    this.inputTarget.value = ""
    this.buttonTarget.style.display = "none"
    this.inputTarget.form.requestSubmit()
  }

  // ── Private ──────────────────────────────────────────────────────────────

  _updateButton() {
    this.buttonTarget.style.display = this.inputTarget.value ? "block" : "none"
  }
}
